
import { ProfileData } from "@/types/profile";

const PROFILE_STORAGE_KEY = 'user_profile';

/**
 * Hook for handling profile data storage in localStorage
 */
export const useProfileStorage = () => {
  /**
   * Save profile data to local storage
   */
  const saveToStorage = (profile: ProfileData) => {
    try {
      localStorage.setItem(PROFILE_STORAGE_KEY, JSON.stringify(profile));
      console.log("Profile saved to local storage");
    } catch (error) {
      console.error("Error saving profile to local storage:", error);
    }
  };

  /**
   * Load profile data from local storage
   */
  const loadFromStorage = (): ProfileData | null => {
    try {
      const cachedData = localStorage.getItem(PROFILE_STORAGE_KEY);
      if (cachedData) {
        const parsedProfile = JSON.parse(cachedData);
        console.log("Profile loaded from local storage");
        return parsedProfile;
      }
    } catch (error) {
      console.error("Error loading profile from local storage:", error);
    }
    return null;
  };

  /**
   * Update specific profile fields in local storage
   */
  const updateStorageFields = (fields: Partial<ProfileData>) => {
    try {
      const existingData = loadFromStorage();
      if (existingData) {
        const updatedProfile = { ...existingData, ...fields };
        saveToStorage(updatedProfile);
        return updatedProfile;
      }
    } catch (error) {
      console.error("Error updating profile fields in local storage:", error);
    }
    return null;
  };

  /**
   * Clear profile data from local storage
   */
  const clearStorage = () => {
    try {
      localStorage.removeItem(PROFILE_STORAGE_KEY);
      console.log("Profile cleared from local storage");
    } catch (error) {
      console.error("Error clearing profile from local storage:", error);
    }
  };

  return {
    saveToStorage,
    loadFromStorage,
    updateStorageFields,
    clearStorage,
    PROFILE_STORAGE_KEY
  };
};
